export default "__VITE_ASSET__3803a473__"